import { render, staticRenderFns } from "./GetInTouch.vue?vue&type=template&id=501b1876&scoped=true&"
import script from "./GetInTouch.vue?vue&type=script&lang=js&"
export * from "./GetInTouch.vue?vue&type=script&lang=js&"
import style0 from "./GetInTouch.vue?vue&type=style&index=0&id=501b1876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b1876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501b1876')) {
      api.createRecord('501b1876', component.options)
    } else {
      api.reload('501b1876', component.options)
    }
    module.hot.accept("./GetInTouch.vue?vue&type=template&id=501b1876&scoped=true&", function () {
      api.rerender('501b1876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/GetInTouch.vue"
export default component.exports